import { render, staticRenderFns } from "./MyProgram.vue?vue&type=template&id=529ba010&scoped=true&"
import script from "./MyProgram.vue?vue&type=script&lang=js&"
export * from "./MyProgram.vue?vue&type=script&lang=js&"
import style0 from "./MyProgram.vue?vue&type=style&index=0&id=529ba010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529ba010",
  null
  
)

export default component.exports